import {NgModule} from '@angular/core';
import {RouterModule, Routes, Router} from '@angular/router';
import {PageOpenSpaceComponent} from './pages/Page_open-space/page-open-space.component';
import {PageHomeComponent} from './pages/Page_home/page-home.component';
import {PageDressesComponent} from './pages/Page_dresses/page-dresses.component';
import {PageScandinavianComponent} from './pages/Page_scandinavian/page-scandinavian.component';
import {PageFashionComponent} from './pages/Page_fashion/page-fashion.component';
import {PageLoftComponent} from './pages/Page_loft/page-loft.component';
import {PageBlackComponent} from './pages/Page_black/page-black.component';
import {PageWhiteSpaceComponent} from './pages/Page_white-space/page-white-space.component';
import {PageEquipmentComponent} from './pages/page-equipment/page-equipment.component';
import {PageRulesComponent} from './pages/page-rules/page-rules.component';
import {PageContactsComponent} from './pages/page-contacts/page-contacts.component';
import {PageThankComponent} from './pages/page-thank/page-thank.component';
import {PagePortfolioComponent} from './pages/page-portfolio/page-portfolio.component';
import {PageCalendarComponent} from './pages/page-calendar/page-calendar.component';
import {Resolver} from './resolver';
import {serviceResolver} from './serviceResolver';
import {PageDressingComponent} from './pages/page-dressing/page-dressing.component';
import { PageServicesComponent } from './pages/page-services/page-services.component';

let routes: Routes = [
	{path: 'hygge-space', component: PageScandinavianComponent, resolve: {halls: Resolver}},
	{path: 'open-space', component: PageOpenSpaceComponent, resolve: {halls: Resolver} },
	{path: 'fashion-space', component: PageFashionComponent , resolve: {halls: Resolver}},
	{path: 'loft-space', component: PageLoftComponent , resolve: {halls: Resolver}},
	{path: 'white-space', component: PageWhiteSpaceComponent , resolve: {halls: Resolver}},
	{path: 'make-up-dress-room', component: PageDressingComponent , resolve: {halls: Resolver}},
	{path: 'black', component: PageBlackComponent , resolve: {halls: Resolver}},
  {path: 'equipment', component: PageEquipmentComponent},
  {path: 'rules', component: PageRulesComponent},
  {path: 'contacts', component: PageContactsComponent},
  {path: 'thank', component: PageThankComponent},
  {path: 'calendar', component: PageCalendarComponent},
  {path: 'portfolio', component: PagePortfolioComponent},
  {path: 'photographers', component: PageDressesComponent},
  {path: '', component: PageHomeComponent},
  {path: 'services/:service', component: PageServicesComponent, resolve: {services: serviceResolver}},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})

export class AppRoutingModule {
}
